import axios from 'axios';
import { put } from 'redux-saga/effects';

import { apiEndpoints } from '../../../../config/config';
import { Creators } from './actions';

// *************************** Fetch Single News Saga ***************************
export function* fetchSingleT3Saga(action) {
  try {
    yield put(Creators.fetchSingleT3Start());
    let url, res;
    let singleT3 = [];
    if (action.postSlug !== null) {
      // url = yield `${apiEndpoints.singleT3}/${action.postSlug}`;
      url = yield `${apiEndpoints.singleNews}/${action.postSlug}`;
      res = yield axios.get(url);
      // console.log('res: ', res);
    } else {
      return;
      // url = yield `${apiEndpoints.getMorePosts}/${action.timeStamp}`;
      // res = yield axios.get(url);
    }
    // console.log('res: ', res);
    // if (res.data.success === 1) {
    if (res.status === 200) {
      for (let key in res.data.post) {
        singleT3.push({
          id: key,
          ...res.data.post[key]
        });
      }
    }
    let payload = {
      postSlug: action.postSlug,
      singleT3: singleT3
    };
    // console.log('singleT3: ', singleT3);
    yield put(Creators.fetchSingleT3Success(payload));
    let tagId, postId;
    if (res.data.post[0].tags && res.data.post[0].tags[0]) {
      tagId = res.data.post[0].tags[0];
    } else {
      tagId = null;
    }
    postId = res.data.post[0].id;
    yield put(Creators.fetchRelatedArticlesForSingleT3(tagId, postId));
  } catch (err) {
    yield put(Creators.fetchSingleT3Failure(err));
  }
}
// ______________________________________________________________________________

// *************************** Fetch Top Picks Saga ***************************
export function* fetchTopPicksSaga(action) {
  try {
    yield put(Creators.fetchTopPicksStart());
    const url = yield apiEndpoints.topNews;
    const res = yield axios.get(url);
    // console.log('res: ', res);
    const topPicks = [];
    if (res.data.success === 1) {
      for (let key in res.data.Top) {
        topPicks.push({
          id: key,
          ...res.data.Top[key]
        });
      }
    }
    // console.log('topPicks: ', topPicks);
    yield put(Creators.fetchTopPicksSuccess(topPicks));
  } catch (err) {
    yield put(Creators.fetchTopPicksFailure(err));
  }
}
// ______________________________________________________________________________

// *************************** Fetch Related Articles Saga ***************************
export function* fetchRelatedArticlesForSingleT3Saga(action) {
  try {
    yield put(Creators.fetchRelatedArticlesForSingleT3Start());
    let url, urlForTags;
    let relatedArticles = [],
      tagsList = [];
    if (action.tagId === null) {
      relatedArticles = [];
      tagsList = [];
    } else {
      url = yield `${apiEndpoints.relatedArticles}/${action.tagId}/${
        action.postId
      }`;
      urlForTags = yield `${apiEndpoints.fetchTagsList}/${action.postId}`;
      const res = yield axios.get(url);
      const resForTags = yield axios.get(urlForTags);
      // console.log('resForTags: ', resForTags);
      // console.log('res: ', res);
      if (res.data.success === 1) {
        for (let key in res.data.related) {
          relatedArticles.push({
            id: key,
            ...res.data.related[key]
          });
        }
      }
      if (resForTags.data.success === 1) {
        for (let key in resForTags.data.tags) {
          tagsList.push({
            id: key,
            ...resForTags.data.tags[key]
          });
        }
      }
    }

    // console.log('relatedArticles: ', relatedArticles);
    // console.log('tagsList: ', tagsList);

    yield put(
      Creators.fetchRelatedArticlesForSingleT3Success({
        relatedArticles,
        tagsList
      })
    );
  } catch (err) {
    console.log('err: ', err);
    yield put(Creators.fetchRelatedArticlesForSingleT3Failure(err));
  }
}
// ______________________________________________________________________________

// *************************** Fetch Best Softwares Saga ***************************
export function* fetchBestSoftwaresSaga(action) {
  try {
    yield put(Creators.fetchBestSoftwaresStart());
    const url = yield apiEndpoints.topNews;
    const res = yield axios.get(url);
    // console.log('res: ', res);
    const bestSoftwares = [];
    if (res.data.success === 1) {
      for (let key in res.data.Top) {
        bestSoftwares.push({
          id: key,
          ...res.data.Top[key]
        });
      }
    }
    // console.log('bestSoftwares: ', bestSoftwares);
    yield put(Creators.fetchBestSoftwaresSuccess(bestSoftwares));
  } catch (err) {
    yield put(Creators.fetchBestSoftwaresFailure(err));
  }
}
// ______________________________________________________________________________
